import {Component} from '@angular/core';
import {StatusDaoService} from '../status-dao.service';
import {ComponentCleaner} from '../../../component-cleaner';
import {SessionNumbers} from '../../../models';
import {ConfirmDialogComponent} from '../../../helpers/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-session-status',
    templateUrl: './session-status.component.html',
    styleUrls: ['./session-status.component.scss', '../status.component.scss']
})
export class SessionStatusComponent extends ComponentCleaner {
    sessionNumbers: SessionNumbers = null;
    loading = false;

    constructor(
        private statusDaoService: StatusDaoService,
        private dialog: MatDialog
    ) {
        super();
        this.getSessionNumbers();
    }

    getSessionNumbers(): void {
        this.sessionNumbers = null;
        this.loading = true;
        this.statusDaoService.getSessionNumbers().subscribe((sessions) => {
            if (sessions) {
                this.sessionNumbers = sessions;
            }
            this.loading = false;
        });
    }

    createUserWithEmptyIP(): void {
        this.addSubscription(this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
                message: '<div>Tem certeza que deseja simular um login de usuário com <b>IP Vazio</b>? ' +
                    '<br><br> Para simular digite o <b>E-MAIL</b> do usuário no campo abaixo</div>',
                disableCancel: false,
                cancelButtonValue: 'Cancelar',
                confirmButtonValue: 'Criar',
                icon: 'error_outline',
                confirmFieldValue: 'CRIAR',
                getResultInput: true
            }
        }).afterClosed().subscribe((email) => {
            console.log('email:', email);
            if (email) {
                this.statusDaoService.createUserWithEmptyIP(email).subscribe((value) => {
                    if (value) {
                        console.log(`Criado usuário com IP vazio para teste`);
                    }
                });
            }
        }));
    }

    clearSessionStorage(): void {
        this.loading = true;
        this.addSubscription(this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
                message: '<div>Tem certeza que deseja limpar todo o <b>BANCO DE DADOS de SESSÃO</b>? ' +
                    '<br><br> Para limpar digite <u>LIMPAR</u> no campo abaixo</div>',
                disableCancel: false,
                cancelButtonValue: 'Cancelar',
                confirmButtonValue: 'Limpar',
                icon: 'error_outline',
                confirmFieldValue: 'LIMPAR'
            }
        }).afterClosed().subscribe((result) => {
            if (result) {
                console.log(`Clear session database 1`);
                this.statusDaoService.clearSessionStorage().subscribe((deleted) => {
                    console.log(`Clear session database 2`, deleted);
                    this.loading = false;
                    setTimeout(() => {
                        this.getSessionNumbers();
                    }, 8000);
                });
            }
        }));
    }

    disconnectAllUsersWithEmptyIP(): void {
        this.loading = true;
        this.addSubscription(this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
                message: '<div>Tem certeza que deseja desconectar todos os <b>USUÁRIOS COM IP VAZIO</b>? ' +
                    '<br><br> Para desconectar digite <u>DESCONECTAR</u> no campo abaixo</div>',
                disableCancel: false,
                cancelButtonValue: 'Cancelar',
                confirmButtonValue: 'Desconectar',
                icon: 'error_outline',
                confirmFieldValue: 'DESCONECTAR'
            }
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.statusDaoService.disconnectAllUsersWithEmptyIP().subscribe((disconnect) => {
                    console.log(`Disconnect All Users With Empty IP`, disconnect);
                    this.loading = false;
                    setTimeout(() => {
                        this.getSessionNumbers();
                    }, 8000);
                });
            }
        }));
    }
}
